// extracted by mini-css-extract-plugin
export default {"ricosDisabled":"dGtqYC","checkbox":"qrLgNy"};